import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import {
  BusinessGroupOutputMultilingual,
  CreateBusinessGroupMultilingual,
  EditBusinessGroupMultilingual,
} from './types';
import {
  thunkErrorHandlerWithoutSdk,
  thunkResponseChecker,
} from '@wajeez-web/core/utils';

export const getBusinessGroupDatatable: ApiMethod<
  Server.BusinessGroupsDataTableInput,
  Server.TableOfBusinessGroupColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroup_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroup_datatable_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getBusinessById: ApiMethod<
  number,
  Server.BusinessGroupOutput,
  any
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroup_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroup_byId_get_V1(id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getBusinessGroupsByUserId: ApiMethod<
  string,
  Server.UserBusinessGroupOutput[]
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroup_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_BusinessGroup_byUser_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getBusinessByIdMultilingual: ApiMethod<
  number | undefined,
  BusinessGroupOutputMultilingual,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseChecker(async () => {
        return identityClient.get(
          'api/identity/v1/admin/BusinessGroup/multilingual-by-id',
          {
            params: {
              Id: id,
            },
          }
        );
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const createBusinessMultilingual: ApiMethod<
  CreateBusinessGroupMultilingual,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseChecker(async () => {
        return identityClient.post('api/identity/v2/admin/BusinessGroup', data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const editBusinessMultilingual: ApiMethod<
  EditBusinessGroupMultilingual,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseChecker(async () => {
        return identityClient.put('api/identity/v2/admin/BusinessGroup', data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
